import React from "react"
import FormInput from "../../../components/Form/Inputs/FormInput"
import ArtPieceSharedDetails from "./SharedDetails"

const ArtPiecePrint = () => {
  return (
    <div className="container">
      <ArtPieceSharedDetails />
      <div className="row">
        <div className="col-6">
          <FormInput
            name="print.width"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
            label="Width"
          />
        </div>
        <div className="col-6">
          <FormInput
            name="print.height"
            label="Height"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
      </div>
      <FormInput
        name="print.edition"
        label="Edition"
        placeholder="E.g. Limited edition, Author print..."
      />
      <div className="row">
        <div className="col-6">
          <FormInput
            name="print.number"
            label="Number"
            placeholder="E.g. 1"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
        <div className="col-6">
          <FormInput
            name="print.numberOf"
            label="Of"
            placeholder="E.g. 5"
            validation={{
              pattern: {
                value: /^[1-9]\d*(\.\d+)?$/,
                message: "This field can be only number",
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ArtPiecePrint
